export default __webpack_public_path__ + "static/media/QV_Points_5.31b0326f.png";